__turbopack_context__.v({
  "Button": "Button-module-scss-module__3iRq6G__Button",
});
